module.exports = "/static/assets/f70d476f0b0ef124a4743a7e96bc4855.png";